import React, { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

export function OrderMonthView(props) {
  const plans = useSelector(state => state.reports.plans);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const _events = plans.map((t, i) => {
      const _d = new Date(t.due_date);
      const _v = _d.getFullYear() + '-' 
        + (_d.getMonth()+1).toString().padStart(2,'0') + '-'
        + _d.getDate().toString().padStart(2,'0');
      
      return {
        title: `${t.work_no.slice(-4)} : ${t.contact_name}`,
        date: _v,
        work_id: t._id
      }
    });

    setEvents(_events);
  }, [plans])

  return (<FullCalendar
    plugins={[ dayGridPlugin ]}
    initialView="dayGridMonth"
    events={events}
    eventClick={(info) => props.onOpen({_id : info.event.extendedProps.work_id})}
  />)
}
